import React from "react";
import { Route, IndexRoute, Redirect } from "react-router";

import createErrorBoundary from "lib/utils/errorBoundary";
const ErrB = createErrorBoundary();

import requireAuth from "modules/app/requireAuth";
import App from "modules/app/App";
import MainLayout from "modules/app/MainLayout";
import AuthLayout from "modules/app/AuthLayout";
import ForbiddenView from "modules/app/ForbiddenView";
import NotFoundView from "modules/app/NotFoundView";

import LoginView from "modules/auth/LoginView/LoginView";
import SendResetPasswordInstructionsView from "modules/auth/SendResetPasswordInstructionsView/SendResetPasswordInstructionsView";
import ResetPasswordView from "modules/auth/ResetPasswordView/ResetPasswordView";
import SendConfirmationInstructionsView from "modules/auth/SendConfirmationInstructionsView/SendConfirmationInstructionsView";
import ConfirmEmailView from "modules/auth/ConfirmEmailView/ConfirmEmailView";
import SendUnlockInstructionsView from "modules/auth/SendUnlockInstructionsView/SendUnlockInstructionsView";
import UnlockAccessView from "modules/auth/UnlockAccessView/UnlockAccessView";

import DashboardView from "modules/dashboard/DashboardView";

import CalendarView from "modules/calendar/CalendarView/CalendarView";

import AccommodationCalendarView from "modules/accommodation/AccommodationCalendarView/AccommodationCalendarView";
import AccommodationSchedulerView from "modules/accommodation/AccommodationSchedulerView/AccommodationSchedulerView";

import OrdersListView from "modules/orders/OrdersListView/OrdersListView";
import ShowOrderView from "modules/orders/ShowOrderView/ShowOrderView";

import ProductsListView from "modules/products/ProductsListView/ProductsListView";
import EditProductView from "modules/products/EditProductView/EditProductView";

import CustomersListView from "modules/customers/CustomersListView/CustomersListView";
import ShowCustomerView from "modules/customers/ShowCustomerView/ShowCustomerView";

import ReviewsListView from "modules/reviews/ReviewsListView/ReviewsListView";

import AgentsListView from "modules/agents/AgentsListView/AgentsListView";
import SuppliersListView from "modules/agents/SuppliersListView/SuppliersListView";
import EditAgentCooperationView from "modules/agents/EditAgentCooperationView/EditAgentCooperationView";

import FinancesListView from "modules/finances/FinancesListView/FinancesListView";

import AffiliateListView from "modules/affiliate/AffiliateListView/AffiliateListView";

import RaportsView from "modules/raports/RaportsView";

import SettingsLayout from "modules/settings/SettingsLayout";
import BillingSettingsView from "modules/settings/BillingSettingsView/BillingSettingsView";
import StripeSettingsView from "modules/settings/StripeSettingsView/StripeSettingsView";
import CompanyMembersView from "modules/settings/CompanyMembersView/CompanyMembersView";
import CompanySettingsView from "modules/settings/CompanySettingsView/CompanySettingsView";
import MarketplaceSettingsView from "modules/settings/MarketplaceSettingsView/MarketplaceSettingsView";
import PaymentsSettingsView from "modules/settings/PaymentsSettingsView/PaymentsSettingsView";
import ProductsSettingsView from "modules/settings/ProductsSettingsView/ProductsSettingsView";
import SaasSettingsView from "modules/settings/SaasSettingsView/SaasSettingsView";
import UserAccountView from "modules/settings/UserAccountView/UserAccountView";
import WidgetsSettingsView from "modules/settings/WidgetsSettingsView/WidgetsSettingsView";

export default (
  <Route component={ErrB(App)}>
    <Redirect from="/test" to="/login" query={{ test: 1 }} />
    <Redirect from="/test-pl" to="/login" query={{ test: 1, test_locale: "pl" }} />
    <Redirect from="/test-en" to="/login" query={{ test: 1, test_locale: "en" }} />
    <Redirect from="/test-ru" to="/login" query={{ test: 1, test_locale: "ru" }} />
    <Route path="/login" component={ErrB(LoginView)} />
    <Route path="/send_reset_password_instructions" component={ErrB(SendResetPasswordInstructionsView)} />
    <Route path="/reset_password" component={ErrB(ResetPasswordView)} />
    <Route path="/send_confirmation_instructions" component={ErrB(SendConfirmationInstructionsView)} />
    <Route path="/confirm_email" component={ErrB(ConfirmEmailView)} />
    <Route path="/send_unlock_instructions" component={ErrB(SendUnlockInstructionsView)} />
    <Route path="/unlock_access" component={ErrB(UnlockAccessView)} />
    <Route path="/" component={ErrB(requireAuth(MainLayout))} />
    <Route component={ErrB(requireAuth(MainLayout))}>
      <Route path="/c/:companyId" component={ErrB(DashboardView)} />
      <Route path="/c/:companyId/calendar" component={ErrB(CalendarView)} />

      <Route path="/c/:companyId/accommodation">
        <IndexRoute component={ErrB(AccommodationCalendarView)} />
        <Route path="/c/:companyId/accommodation/scheduler" component={ErrB(AccommodationSchedulerView)} />
      </Route>

      <Route path="/c/:companyId/orders">
        <IndexRoute component={ErrB(OrdersListView)} />
        <Route path="/c/:companyId/orders/:id/:token" component={ErrB(ShowOrderView)} />
      </Route>

      <Route path="/c/:companyId/products">
        <IndexRoute component={ErrB(ProductsListView)} />
        <Route path="/c/:companyId/products/:id/edit" component={ErrB(EditProductView)} />
      </Route>

      <Route path="/c/:companyId/customers">
        <IndexRoute component={ErrB(CustomersListView)} />
        <Route path="/c/:companyId/customers/:id" component={ErrB(ShowCustomerView)} />
      </Route>

      <Route path="/c/:companyId/reviews">
        <IndexRoute component={ErrB(ReviewsListView)} />
      </Route>

      <Route path="/c/:companyId/agents">
        <IndexRoute component={ErrB(AgentsListView)} />
        <Route path="/c/:companyId/agents/:id" component={ErrB(EditAgentCooperationView)} />
      </Route>

      <Route path="/c/:companyId/suppliers">
        <IndexRoute component={ErrB(SuppliersListView)} />
        <Route path="/c/:companyId/suppliers/:id" component={ErrB(EditAgentCooperationView)} />
      </Route>

      <Route path="/c/:companyId/finances">
        <IndexRoute component={ErrB(FinancesListView)} />
      </Route>

      <Route path="/c/:companyId/affiliate">
        <IndexRoute component={ErrB(AffiliateListView)} />
      </Route>

      <Route path="/c/:companyId/raports">
        <IndexRoute component={ErrB(RaportsView)} />
      </Route>

      <Redirect from="/c/:companyId/settings" to="/c/:companyId/settings/company/account" />
      <Route path="/c/:companyId/settings" component={ErrB(SettingsLayout)}>
        <Route path="/c/:companyId/settings/user/account" component={ErrB(UserAccountView)} />
        <Route path="/c/:companyId/settings/company/account" component={ErrB(CompanySettingsView)} />
        <Route path="/c/:companyId/settings/company/members" component={ErrB(CompanyMembersView)} />
        <Route path="/c/:companyId/settings/company/products" component={ErrB(ProductsSettingsView)} />
        <Route path="/c/:companyId/settings/company/payments" component={ErrB(PaymentsSettingsView)} />
        <Route path="/c/:companyId/settings/company/billing" component={ErrB(BillingSettingsView)} />
        <Route path="/c/:companyId/settings/company/stripe" component={ErrB(StripeSettingsView)} />
        <Route path="/c/:companyId/settings/company/stripe/:status" component={ErrB(StripeSettingsView)} />
        <Route path="/c/:companyId/settings/integrations/marketplace" component={ErrB(MarketplaceSettingsView)} />
        <Route path="/c/:companyId/settings/integrations/saas" component={ErrB(SaasSettingsView)} />
        <Route path="/c/:companyId/settings/integrations/widgets" component={ErrB(WidgetsSettingsView)} />
        <Redirect from="/c/:companyId/settings/user" to="/c/:companyId/settings/user/account" />
        <Redirect from="/c/:companyId/settings/company" to="/c/:companyId/settings/company/account" />
        <Redirect from="/c/:companyId/settings/integrations" to="/c/:companyId/settings/integrations/marketplace" />
      </Route>

      <Route path="/c/:companyId/403" component={ForbiddenView} />
      <Route path="/c/:companyId/404" component={NotFoundView} />
      <Route path="/c/:companyId/*" component={NotFoundView} />
    </Route>
    <Route path="403" component={ForbiddenView} />
    <Route path="*" component={NotFoundView} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes.js